import { render, staticRenderFns } from "./register_form.vue?vue&type=template&id=36049142&scoped=true&"
import script from "./register_form.vue?vue&type=script&lang=js&"
export * from "./register_form.vue?vue&type=script&lang=js&"
import style0 from "./register_form.vue?vue&type=style&index=0&id=36049142&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36049142",
  null
  
)

export default component.exports